import { useState, useEffect } from 'react'
import { Box, Typography, TextField, Button, Stack, IconButton, InputAdornment, } from '@mui/material'
import Visibility from '@mui/icons-material/VisibilityOutlined'
import VisibilityOff from '@mui/icons-material/VisibilityOffOutlined'
import { useNavigate } from 'react-router-dom'
import { useIsMobile } from '@/hooks/Responsive'
import { passwordCheck } from "@api/myPageAccount";
import { useConfirm } from '@components/ConfirmProvider'
import { useAuth } from '@components/AuthContext';
import { useLang } from '@/i18n/useLang'
import { buildLangHref } from '@data/nav'

export default function MyAccountCheck() {

  const { user, loading, isAuthReady } = useAuth();

  const { isMobile } = useIsMobile()
  const lang = useLang()
  
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const navigate = useNavigate()

  const { alert, confirm } = useConfirm();

  useEffect(() => {
    // 아직 로딩 중이면 아무 것도 하지 않음
    if (loading) return;

    // 최초 호출될 api 실행

  }, [loading, user])

  const handleSubmit = async () => {
    if (!password.trim()) return
    
    // user가 없으면 바로 로그인 페이지로 (이미 세션 만료 alert는 전역에서 띄웠다고 가정)
    if (!user) {
      // 세션이 만료되어 user가 null인 상태
      // ProtectedRoute에 의해 곧 /login 으로 이동되므로, 여기서는 그냥 return만 해도 됨.
      // 필요하다면 아래처럼 직접 보내도 됨:
      // navigate('/login');
      return;
    }

    try {
      const params = {
        publicId : user.pid,
        memberPassword : password,
      };
      const response = await passwordCheck(params);

      if (response?.success) {
        // sessionStorage.setItem('accountVerified', 'true')
        navigate(buildLangHref('/mypage/account', lang))
      }
      else {
        alert(response?.message || "조회 중 오류가 발생했습니다.");
      }
    } catch (e) {
      //console.error(e);
      // 401 은 전역 인터셉터에서 "세션 만료" alert를 이미 띄우므로, 여기서는 중복 alert 방지
      if (e?.response?.status === 401) {
        return;
      }
      alert(e?.response?.data?.message || e.message || "조회 중 오류가 발생했습니다.");
    }
    
  }


  return (
    <>
      <Typography component="p" variant={isMobile ? 'subtitle3' : 'subtitle2'} fontWeight={400} sx={{ mb: 4 }}>
        소중한 개인정보관리를 위해 사용 중인 비밀번호를 한 번 더 입력해 주세요.
      </Typography>

      {/* 비밀번호 */}
      <Box>
        <Typography fontWeight={500} sx={{ mb: 1 }}>
          비밀번호
        </Typography>

        <Stack direction={isMobile ? 'column' : 'row'} sx={{ gap: 1 }}>
          <TextField
            fullWidth
            type={showPassword ? 'text' : 'password'}
            placeholder="비밀번호를 입력해 주세요"
            size="small"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleSubmit(e)
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" sx={{ pr: 3 }}>
                  <IconButton
                    edge="end"
                    onClick={() => setShowPassword((prev) => !prev)}
                  >
                    {showPassword ? <Visibility sx={{ color: 'grey.dark' }} /> : <VisibilityOff sx={{ color: 'grey.dark' }} />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <Button
            variant="outlined"
            color="primary"
            onClick={handleSubmit}
          >
            확인
          </Button>
        </Stack>
      </Box>
    </>
  )
}
